import { Box, CircularProgress } from '@material-ui/core';
import { formatMoney, LenderName } from '@nemuru-eng/js-api-client';
import { PricingFromCdn } from '@nemuru-eng/js-api-client/slim';

import { LenderIconAvatar } from '@/components/shared/components/Logo/LenderLogo/LenderIcon';
import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { CustomDivider } from '@/components/shared/components/CustomDivider';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface SelectOptionsComponentProps {
  selectOption: PricingFromCdn;
  loading?: boolean;
  lenderNames?: { lenderName: LenderName; id: string }[] | undefined;
}

export const SelectOptionsComponent = ({ selectOption, loading, lenderNames }: SelectOptionsComponentProps) => {
  const { getTextIdTranslation } = useTranslation();
  const optionLenderIds = [...new Set(selectOption.ranges.flatMap((item) => item.lenderIds ?? []))].sort((a, b) =>
    a.localeCompare(b),
  );

  if (loading) return <></>;

  return (
    <>
      <Box display={'flex'} flexDirection={'column'} justifyContent={'center'} gridGap={4}>
        <Font variant="body2" color="textSecondary">
          <strong>{selectOption.name}</strong>
        </Font>
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'} justifyContent={'flex-start'}>
          <Font variant="caption">
            <Text tId={selectOption.program} />
          </Font>
          <CustomDivider orientation="vertical" minHeight={'12px'} />
          {selectOption.rangePeriodMin && selectOption.rangePeriodMax && (
            <>
              <Font variant="caption">
                {`${selectOption.rangePeriodMin} - ${selectOption.rangePeriodMax} ${getTextIdTranslation('MONTHS')}`}
              </Font>
              <CustomDivider orientation="vertical" minHeight={'12px'} />
            </>
          )}
          <Font variant="caption">
            {`${formatMoney(selectOption.rangePrincipalMin)} - ${formatMoney(selectOption.rangePrincipalMax)}`}
          </Font>
          <CustomDivider orientation="vertical" minHeight={'12px'} />
          <Box display={'flex'} flexDirection={'row'} gridGap={4}>
            {optionLenderIds.map((lenderId) => {
              if (!lenderNames) return <CircularProgress color="secondary" size={14} />;
              const lenderName = lenderNames.find((name) => name.id === lenderId)?.lenderName;
              if (!lenderName) return <></>;
              return <LenderIconAvatar size="small" lenderName={lenderName} />;
            })}
          </Box>
        </Box>
      </Box>
    </>
  );
};
